import {useMemo} from 'react'

type Props = {
  protocol?: 'vscode' | 'vscode-insiders'
  repositoryNwo: string
  globalId: string
  headRefName?: string
}

export function useVSCodeAgentSessionUrl({protocol = 'vscode', repositoryNwo, globalId, headRefName}: Props) {
  return useMemo(() => {
    if (!headRefName) return

    const repoUrl = `https://github.com/${repositoryNwo}.git`

    return `${protocol}://GitHub.copilot-chat/openAgentSession?id=${globalId}&type=copilot&url=${encodeURIComponent(
      repoUrl,
    )}&branch=${encodeURIComponent(headRefName)}`
  }, [protocol, repositoryNwo, globalId, headRefName])
}
